"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingInvalidFiles = void 0;
var React = require("react");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var LoadingInvalidFiles = function () { return (React.createElement("div", { className: 'center-content' },
    React.createElement("div", { className: 'loading-invalid-files' },
        React.createElement("div", null,
            React.createElement(sok_ui_1.LoadingSpinner, { key: 'spinner' })),
        React.createElement("div", { key: 'text', className: 'information-text' }, (0, translation_1.getLocalization)('userfront/shoppingcart/step1/checkingFiles/loading'))))); };
exports.LoadingInvalidFiles = LoadingInvalidFiles;
